import React from 'react'
import "../css/jp_Search.css"
import { SearchIconFilter } from '../../../../assets-module/asset-configuration/icon/iconExporter/iconExporter'

type Props = {
  value: string;
  onChange: (value: string) => void;
};

const JPSearch: React.FC<Props> = ({ value, onChange }) => {
  const hasValue = value.trim().length > 0;

  return (
    <section className="scl--jps-sec-con-st">
      <div  className={`scl--jscs-inp-con-st ${
          hasValue ? "scl--jscs-inp-con-st--has-value" : ""
        }`}
      >
        <SearchIconFilter />
        <input
          type="text"
          placeholder="Search for position..."
          autoComplete="off"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </section>
  );
};

export default JPSearch;
